// @ts-nocheck
import React from "react";
import styled from "styled-components";
import { PageHeader } from "antd";

const DiscoverHeader = styled(PageHeader)`
  && {
    background: #f0f2f5;
    .ant-page-header-heading-title {
      font-size: 24px;
    }
    .ant-page-header-heading-sub-title {
      display: block !important;
    }
  }
`;

interface Props {
  title: string;
  subTitle: string;
}

const HeroActions: React.FC<Props> = ({ title, subTitle }) => {
  return <DiscoverHeader title={title} subTitle={subTitle} />;
};

export default HeroActions;
